import api from "./api";

export function hasPendingOrder(scope) {
  return Boolean(localStorage.getItem(`vagenpar_checkout_v2:${scope}`));
}

export async function recoverOrder(scope) {
  const key = `vagenpar_checkout_v2:${scope}`;
  const pending = JSON.parse(localStorage.getItem(key) || "null");
  if (!pending) return null;
  const response = await sendOrder(scope, pending.payload);
  return response.data;
}

// Persist the exact submitted body until acknowledgement, including across reloads.
export async function sendOrder(scope, payload) {
  const storageKey = `vagenpar_checkout_v2:${scope}`;
  const intent = JSON.stringify({ cari_id: payload.cari_id, not_: payload.not_,
    lines: payload.satirlar.map(({ stok_id, miktar }) => ({ stok_id, miktar })).sort((a, b) => a.stok_id.localeCompare(b.stok_id)) });
  let pending = JSON.parse(localStorage.getItem(storageKey) || "null");
  if (pending && pending.intent !== intent) {
    throw new Error("Önceki gönderimin sonucu belirsiz. Önce aynı sepeti tekrar göndererek sonucunu kontrol edin; ürün ve not değişikliklerini geri alın.");
  }
  if (!pending) {
    pending = { intent, payload: { ...payload, istek_id: crypto.randomUUID() } };
  }
  pending.payload.bakiye_onayi = payload.bakiye_onayi;
  localStorage.setItem(storageKey, JSON.stringify(pending));
  while (true) {
  try {
    const response = await api.post("/siparisler/", pending.payload);
    localStorage.removeItem(storageKey);
    return response;
  } catch (error) {
    const detail = error.response?.data?.detail;
    if (error.response?.status === 409 && detail?.code === "PRICE_CHANGE_CONFIRMATION") {
      const money = (value) => Number(value).toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
      const lines = (detail.items || []).map((line) => `${line.stok_kodu}: ${money(line.eski_fiyat)} → ${money(line.yeni_fiyat)} (${line.miktar} adet)`).join("\n");
      if (window.confirm(`${detail.message}\n\n${lines}\n\nÖnceki toplam: ${money(detail.eski_toplam)}\nYeni toplam: ${money(detail.yeni_toplam)}`)) {
        pending.payload.fiyat_onayi = detail.fiyat_onayi;
        localStorage.setItem(storageKey, JSON.stringify(pending));
        continue;
      }
      localStorage.removeItem(storageKey);
      throw new Error("Fiyat değişikliği onaylanmadı. Sipariş oluşturulmadı.");
    }
    // A validation rejection committed nothing; a timeout/5xx must keep the key.
    if ([400, 403, 404, 422, 428].includes(error.response?.status) ||
        error.response?.data?.detail?.code === "INSUFFICIENT_STOCK_CONFIRMATION") localStorage.removeItem(storageKey);
    throw error;
  }
}
}
